import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template"]

  open(event) {
    event.preventDefault()
    this.dialog = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.dialog.addEventListener("click", this.close.bind(this))
    this.dialog.addEventListener("keydown", this.close.bind(this))
    this.dialog.addEventListener("close", () => this.dialog.remove())
    this.element.append(this.dialog)
    this.dialog.showModal()
  }

  close(event) {
    const closeButton = event.target.closest("[data-avatar-preview-close]")

    if (event.target === this.dialog || (closeButton && (event.type === "click" || [ "Enter", " " ].includes(event.key)))) {
      event.preventDefault()
      this.dialog.close()
    }
  }
}
